import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { SlideshowItemProps } from './SlideshowItem';
import SlideshowItemIcon from './SlideshowItemIcon';

export type SlideshowOR4TechSpecsContentProps = Pick<
  SlideshowItemProps,
  'content' | 'contentTitle' | 'showDiscount'
>;

const SlideshowOR4TechSpecsContent = ({
  showDiscount,
  contentTitle,
  content,
}: SlideshowOR4TechSpecsContentProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div
      className={cx('relative mx-2', {
        'top-24 md:top-28 lg:top-32': showDiscount,
        'top-12 md:top-16 lg:top-20': !showDiscount,
      })}
    >
      <TypographyV3
        className="mb-2 text-body-lg text-white md:mb-4 md:text-heading-xl"
        color="unset"
        variant="unset"
        align="center"
        weight="normal"
        Element="div"
      >
        {t(contentTitle)}
      </TypographyV3>
      <div className="flex justify-center" data-cy="OR4-tech-spec-content">
        {content?.map((item, idx) =>
          item ? (
            <div
              key={idx}
              className="flex w-1/5 flex-col items-center text-white lg:w-1/4"
            >
              <div className="mb-1">
                <SlideshowItemIcon
                  className="size-[25px] md:size-[42px]"
                  iconName={item.iconName}
                />
              </div>
              <TypographyV3
                className="text-[8px] md:text-base"
                color="inherit"
                variant="unset"
                align="center"
                weight="normal"
                height="tight"
                Element="div"
              >
                {t.rich(item.heading)}
              </TypographyV3>
            </div>
          ) : null,
        )}
      </div>
    </div>
  );
};

export default SlideshowOR4TechSpecsContent;
